module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-17-d3d5bd342abc656ef4c8008b4dc47953.png";